module.exports = __webpack_public_path__ + "fonts/Montserrat-MediumItalic.fafaedc0.ttf";